import React, { useState, useEffect } from "react";
import {
  Typography,
  makeStyles,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import { useHistory } from "react-router-dom";

import Loader from "../../components/Loader";
import axios from "axios";

import { TEAMS, ASSIGN_FARMS, PROJECT, USERS } from "../../configs/urls";
import { API_BASE_URL, ROLES } from "../../configs/constant";

import { getApi, postApi, putApi } from "../../services/api";
import ViewSubTeam from "./ViewSubTeam";
import SubTeam from "./subTeam";
import "./style.css";
import { sectorOfficerTeamDetails } from "store/store";
import { useAtom } from "jotai";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  listContainer: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  clearAllButton: {
    minWidth: "130px !important",
    paddingLeft: 8,
    paddingRight: 8,
    marginTop: 10,
    paddingBottom: 3,
    marginLeft: 20,
  },
}));

const modalStyle = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },

  dialogPaper: { width: "1000px" },
});

export default function Jobs(props) {
  const classes = useStyles();
  const [teams, setTeamsList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [filteredProjectListForSO, setFilteredProjectListForSO] = useState();
  const [teamParams, setTeamParams] = useState({
    project_id: "",
    sector_officer_id: "",
  });
  const [userRole, setUserRole] = useState();

  const [sectorOfficerList, setSectorOfficerList] = useState([]);

  const [selectedTeam, setSelectedTeam] = useState({});
  const [params, setParams] = useState({
    project_id: "",
    sector_officer_id: "",
  });
  const [isRequesting, setIsRequestig] = useState(false);
  const [teamDetails, setTeamDetails] = useAtom(sectorOfficerTeamDetails);
  // const [projectDataNow, setProjectDataNow] = useState([]);
  const history = useHistory();

  const getProjectList = async () => {
    await axios.get(`${API_BASE_URL}/${PROJECT}`).then((res) => {
      setProjectList(res?.data);
    });
  };

  // const getTeamsList = async (teamIdNew) => {
  //   const sector_officer_id = localStorage?.getItem("sectorOfficerId");
  //   const project_id = localStorage?.getItem("projectId");
  //   await axios
  //     .get(
  //       `${API_BASE_URL}/${TEAMS}?sector_officer_id=${sector_officer_id}&project_id=${project_id}`
  //     )
  //     .then((res) => {
  //       const teamNow = res?.data?.find((items) => items?.id == teamIdNew);
  //       setSelectedTeam(teamNow);
  //     });
  // };

  // useEffect(() => {
  //   if (teamParams?.project_id) {
  //     return localStorage?.setItem("projectId", teamParams?.project_id);
  //   }
  // }, [teamParams?.project_id]);

  useEffect(() => {
    getAllData();
  }, []);

  // useEffect(() => {
  //   if (teamParams?.sector_officer_id) {
  //     return localStorage?.setItem(
  //       "sectorOfficerId",
  //       teamParams?.sector_officer_id
  //     );
  //   }
  // }, [teamParams?.sector_officer_id]);

  // useEffect(() => {
  //   const teamId = localStorage?.getItem("teamId");
  //   if (teamId) {
  //     // getTeamsList(teamId);
  //   }
  //   // if (teamId) {
  //   //   handleTeamChange(teamId);
  //   // }
  // }, [localStorage?.getItem("teamId")]);

  // useEffect(() => {
  //   if (localStorage?.getItem("projectId")) {
  //     setTeamParams({
  //       project_id: Number(localStorage?.getItem("projectId")),
  //       sector_officer_id: "",
  //     });
  //     handleProjectChange(Number(localStorage?.getItem("projectId")));
  //     getProjectList();
  //   }
  //   if (localStorage?.getItem("sectorOfficerId")) {
  //     setTeamParams({
  //       project_id: Number(localStorage?.getItem("projectId")),
  //       sector_officer_id: Number(localStorage?.getItem("sectorOfficerId")),
  //     });
  //     fetchTeams(Number(localStorage?.getItem("sectorOfficerId")));
  //   }
  //   getProjectList();
  // }, []);

  // useEffect(() => {
  //   if (projectList) {
  //     const projectData = projectList.find(
  //       (project) => project.id == Number(localStorage?.getItem("projectId"))
  //     );

  //     setProjectDataNow(projectData?.sector_officers);
  //     // setSectorOfficerList(projectData.sector_officers);
  //     // setSectorOfficerList
  //   }
  // }, [projectList]);

  useEffect(() => {
    if (
      props.match &&
      props.match.params &&
      (props.match.params.sector_officer_id || props.match.params.project_id)
    ) {
      setTeamParams({
        project_id: props.match.params.project_id,
        sector_officer_id: props.match.params.sector_officer_id,
      });
    }
    // setSectorOfficerList(projectDataNow);
  }, [sectorOfficerList]); //eslint-disable-line

  const getAllData = async () => {
    let params = {
      sector_officer_id: "",
      project_id: "",
    };

    if (props.match && props.match.params && props.match.params.project_id) {
      params.project_id = props.match.params.project_id;
    }

    if (
      props.match &&
      props.match.params &&
      props.match.params.sector_officer_id
    ) {
      params.sector_officer_id = props.match.params.sector_officer_id;
    }

    setIsRequestig(true);

    const projects = getApi(PROJECT, params);

    await axios
      .all([projects])
      .then((res) => {
        if (res[0] && res[0].data) {
          setProjectList(res[0].data);
          if (
            props.match &&
            props.match.params &&
            props.match.params.project_id &&
            props.match.params.sector_officer_id
          ) {
            const tempProjectList = res[0].data || [];
            const projectData = tempProjectList.find(
              (project) => project.id == props.match.params.project_id
            );
            setTeamsList([]);
            if (projectData?.sector_officers)
              setSectorOfficerList(projectData.sector_officers);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const fetchTeams = (sector_officer_id) => {
    setIsRequestig(true);

    let params = {
      sector_officer_id: teamParams.sector_officer_id
        ? teamParams.sector_officer_id
        : // : localStorage?.getItem("sectorOfficerId")
          // ? localStorage?.getItem("sectorOfficerId")
          "",
      project_id: teamParams.project_id
        ? teamParams.project_id
        : // : localStorage?.getItem("projectId")
          // ? localStorage?.getItem("projectId")
          "",
    };
    if (sector_officer_id) params = { ...params, sector_officer_id };
    getApi(TEAMS, params)
      .then((res) => {
        // setTeamDetails(res);
        setTeamsList(res.data);
        if (selectedTeam && selectedTeam.id) {
          const tempTeam = res.data.find((team) => team.id === selectedTeam.id);
          setSelectedTeam(tempTeam);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const handleProjectChange = (e) => {
    const projectData = projectList.find(
      (project) => project.id == e.target.value
    );
    setTeamsList([]);
    setTeamParams({ ...teamParams, sector_officer_id: "" });
    setSelectedTeam({});
    if (projectData?.sector_officers)
      setSectorOfficerList(projectData.sector_officers);

    setTeamParams({
      ...teamParams,
      project_id: e.target.value,
      sector_officer_id: "",
    });
  };

  const handleSectorOfficerChange = (e) => {
    setTeamParams({ ...teamParams, sector_officer_id: e.target.value });
    setSelectedTeam({});
    fetchTeams(e.target.value);
  };
  const handleTeamChange = (e) => {
    const team = teams.find((team) => team.id === e.target.value);
    setSelectedTeam(team);
  };

  useEffect(() => {
    const dataNew = localStorage?.getItem("user");
    setUserRole(JSON.parse(dataNew)?.role?.name);
  }, []);

  const changeProjectList = () => {
    return projectList?.map((item) => {
      console.log(
        "item?.sector_officers?.[0]?.user_details?.name === userRole",
        item?.sector_officers?.[0]?.user_details?.name === userRole
      );
      if (item?.sector_officers?.[0]?.user_details?.name === userRole) {
      }
    });
  };

  // changeProjectList();

  useEffect(() => {
    changeProjectList();
  }, [projectList]);

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer alignItems="center">
            <GridItem xs={12} sm={6} md={9}>
              <Typography variant="h6" className={classes.title}>
                Teams Overview
              </Typography>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{
                  minWidth: 170,
                  marginRight: 21,
                  height: 70,
                  width: "100%",
                }}
              >
                <InputLabel id="project-filter-select-outlined-label">
                  Project
                </InputLabel>
                <Select
                  labelId="project-filter-select-outlined-label"
                  id="project-filter-select-outlined"
                  value={teamParams.project_id}
                  label="District"
                  onChange={handleProjectChange}
                >
                  {projectList && projectList.length > 0 ? (
                    projectList.map((project, idx) => (
                      <MenuItem key={idx} value={project.id}>
                        {project.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value={""}>No Option</MenuItem>
                  )}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <ViewSubTeam
            team={selectedTeam}
            projectList={projectList}
            teams={teams}
            sectorOfficerList={sectorOfficerList}
            selectedTeam={selectedTeam}
            teamParams={teamParams}
            handleSectorOfficerChange={handleSectorOfficerChange}
            handleTeamChange={handleTeamChange}
            handleProjectChange={handleProjectChange}
            callBackFunction={() => {
              fetchTeams();
            }}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
